/**
 * 5) « Mon historique » : les 3 derniers cours (SPEC MC6 ; retour de Ségolène du 15/10, 10 avant) + lien
 * « Voir tous mes cours ». Tranche côté client des visites déjà chargées (GET client/visits) :
 * aucun appel en plus. Sans spot (retour M5).
 *
 * Visites en échec, rien en cache (erreur, ou pause hors ligne ; relecture du 09/10) : « Historique indisponible pour
 * le moment », à la place exacte du squelette (Ui.tsx UnavailableBlock), plus « Aucun cours passé pour l'instant ».
 */
import { useListVisits } from 'hooks/useApiQueries';
import { useMemo } from 'react';
import { sourceFailed } from '../lib/query';
import {
  CONVERTED_VISIT_NOTE,
  HISTORY_ON_ACCOUNT,
  isConvertedVisit,
  lastVisits,
  OUTCOME_LABEL,
  visitOutcome,
} from '../lib/visits';
import { useVisitLookup } from '../hooks';
import { Dots, VisitRow } from './VisitRow';
import { BrandTag, SectionHead, Tag, UnavailableBlock } from './Ui';

export function History() {
  const visitsQuery = useListVisits() || {};
  const { data: visits, isLoading } = visitsQuery;
  const unavailable = sourceFailed(visitsQuery);
  const { studioOf, coachOf, brandOf, currentSiteId } = useVisitLookup();
  const last = useMemo(() => lastVisits(visits, HISTORY_ON_ACCOUNT), [visits]);

  return (
    <section className="mmv2-acct-section" aria-labelledby="mmv2-acct-history">
      <SectionHead
        id="mmv2-acct-history"
        title="Mon historique"
        link={last.length ? { to: '/account/visits#cours-passes', label: 'Voir tous mes cours' } : undefined}
      />
      <div className="mmv2-card mmv2-card--pad mmv2-acct-block">
        {unavailable ? (
          <UnavailableBlock>Historique indisponible</UnavailableBlock>
        ) : isLoading ? (
          <div className="mmv2-acct-skeleton" aria-busy="true" aria-label="Chargement de votre historique" />
        ) : last.length ? (
          <ul className="mmv2-acct-vlist mmv2-acct-vlist--history" data-count={last.length}>
            {last.map((visit) => {
              const outcome = OUTCOME_LABEL[visitOutcome(visit)];
              const otherSite = String(visit.SiteId) !== String(currentSiteId);
              const showOutcome = outcome && visitOutcome(visit) !== 'show';
              return (
                <VisitRow
                  key={visit.Id}
                  visit={visit}
                  subline={
                    isConvertedVisit(visit) ? (
                      CONVERTED_VISIT_NOTE
                    ) : (
                      <Dots parts={[studioOf(visit.SiteId, visit.LocationId), coachOf(visit.SiteId, visit.StaffId)]} />
                    )
                  }
                  aside={
                    otherSite || showOutcome ? (
                      <>
                        {otherSite ? <BrandTag brand={brandOf(visit.SiteId)} /> : null}
                        {showOutcome && outcome ? <Tag tone={outcome.tone}>{outcome.label}</Tag> : null}
                      </>
                    ) : undefined
                  }
                />
              );
            })}
          </ul>
        ) : (
          <p className="mmv2-muted">Aucun cours passé pour l’instant.</p>
        )}
      </div>
    </section>
  );
}
